import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import EmptyIcon from "../../../../assets/images/icons/empty-prescription.svg";
import { InfiniteScroll, TitleWithArrowLink } from "../../../../components";
import { EndPoints } from "../../../../Constants/endpoints";
import { Prescription } from "../../../../interface/GeneralResponse";
import { CardWithIconSkeleton } from "../../../../Share";
import { PrescriptionDetailsAccordion } from "../../../MyPrescriptions/components";

function PrescriptionsDetails() {
  const { t } = useTranslation();
  const { id, accountId } = useParams();
  const [prescriptionData, setPrescriptionData] = useState<Prescription[]>();
  console.log("prescriptionData", prescriptionData);

  return (
    <div className="box h-full overflow-auto">
      <TitleWithArrowLink title="prescriptions_by_doctors" />
      <div className="grid grid-cols-1 gap-3">
        {(prescriptionData?.length ?? 0) > 0 &&
          prescriptionData?.map((e) => (
            <PrescriptionDetailsAccordion key={e.Id} data={e} />
          ))}
        <InfiniteScroll
          Count={10}
          skeletonCount={10}
          endpoint={EndPoints.GetPrescriptionsByDoctorIdForPatient}
          getAllParams={{ PatientId: id, AccountId: accountId }}
          getData={(data) => setPrescriptionData(data)}
          renderSkeleton={<CardWithIconSkeleton />}
          noDataElement={
            <div className="flex h-[34vh] flex-col items-center justify-center gap-4 lg:w-[36%]">
              <img
                alt="empty"
                className="max-w-32 opacity-70"
                src={EmptyIcon}
              />
              <h4 className="text-center text-body-text">{t("no_data_yet")}</h4>
            </div>
          }
        />
      </div>
    </div>
  );
}

export default PrescriptionsDetails;
